/** GoBar command parsing and display-item builders. */

/**
 * Detecteer of de volledige invoer uitsluitend #project- of @context-tags bevat.
 * @returns {{ projects: string[], contexts: string[] } | null}
 */
export const parseCommand = (term) => {
  const projects = [...term.matchAll(/#([^\s,]+)/g)].map((m) =>
    m[1].toLowerCase(),
  );
  const contexts = [...term.matchAll(/@([^\s,]+)/g)].map((m) =>
    m[1].toLowerCase(),
  );

  const stripped = term
    .replace(/#\S+/g, '')
    .replace(/@\S+/g, '')
    .replace(/[,\s]+/g, '');
  if (stripped.length > 0) return null;
  if (projects.length === 0 && contexts.length === 0) return null;

  return { projects, contexts };
};

export const buildGoBarDisplayItems = ({ command, results, searchTerm, t }) => {
  if (command) {
    const parts = [];
    if (command.projects.length > 0)
      parts.push(command.projects.map((v) => `#${v}`).join(', '));
    if (command.contexts.length > 0)
      parts.push(command.contexts.map((v) => `@${v}`).join(', '));
    const label = t('gobar.filterCommand', '→ Organize: show only {tags}', {
      tags: parts.join(', '),
    });
    const id = `cmd-filter-${command.projects.join('-')}-${command.contexts.join('-')}`;
    return [{ id, isCommand: true, title: label }];
  }
  const trimmed = searchTerm.trim();
  if ((results?.length ?? 0) === 0 && trimmed) {
    return [
      {
        id: 'create',
        isCreate: true,
        title: t('gobar.createTask', 'Create task: "{query}"', {
          query: trimmed,
        }),
      },
    ];
  }
  return results ?? [];
};
